import { memo } from 'react'
import PauseCircleIcon from '@mui/icons-material/PauseCircle'
import BaseNode from './BaseNode'
import { WorkflowNodeData } from '@store/workflowStore'

interface TimerControlNodeProps {
  id: string
  data: WorkflowNodeData
  selected?: boolean
}

function TimerControlNode(props: TimerControlNodeProps) {
  return (
    <BaseNode
      {...props}
      icon={<PauseCircleIcon fontSize="small" />}
      showTargetHandle={true}
      showSourceHandle={true}
    />
  )
}

export default memo(TimerControlNode)
